module.exports = __webpack_public_path__ + "static/media/allergy_slider_phone2.c603ea21.png";